export default {
  PeriodicidadesParaOcorrencias: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "periodicidades-para-recorrencia"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/PeriodicidadesParaOcorrencias.js
// module id = AJpP
// module chunks = 18